var render = function render(){var _vm=this,_c=_vm._self._c;return _c('move-template',{attrs:{"order-type":_vm.queryParam.value.business.orderType,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }